enum IDMSegmentField {
    version,
    final,
    encoding,
    length,
    data,
}

export default IDMSegmentField;
